// libraries
import React from 'react';
import Route from 'react-router/lib/Route';
import store from 'store';

// actions
import {
  handleRouteLeave,
  handleSetupHomeRouteEnter,
  handleSetupCreateRouteEnter,
  handleSetupUpdateRouteEnter,
  handleUpdateCommunicationRouteEnter,
  handleSetupPermissionsRouteEnter,
  handleSetupEventsRouteEnter,
  handleSetupSquadsRouteEnter,
  handleSetupDivisionsRouteEnter,
  handleSetupCapacityRouteEnter,
  handleSetupFeesRouteEnter,
  handleSetupStatusRouteEnter,
  handleSetupRestrictionsRouteEnter
} from './actions';

// components
import SetupHomeContainer from './home/SetupHomeContainer.jsx';
import SetupAddGeneralContainer from './general/AddGeneralContainer.jsx';
import SetupUpdateGeneralContainer from './general/UpdateGeneralContainer.jsx';
import CommunicationFormContainer from './communications/CommunicationFormContainer.jsx';
import PermissionsFormContainer from './permissions/PermissionsFormContainer.jsx';
import EventsContainer from './events/EventsContainer.jsx';
import SquadsContainer from './squads/SquadsContainer.jsx';
import StatusContainer from './status/StatusContainer.jsx';
import DivisionsContainer from './divisions/DivisionsContainer.jsx';
import CapacityContainer from './capacity/CapacityContainer.jsx';
import FeesContainer from './fees/FeesContainer.jsx';
import RestrictionsTabContainer from './restrictions/RestrictionsTabContainer.jsx';

const managerRole = "superuser,manager";

const routes = (
  <div>
    <Route path="tournament"
      component={SetupHomeContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupHomeRouteEnter(nextState, replace, callback))}
    />
    <Route path="tournament/create"
      component={SetupAddGeneralContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupCreateRouteEnter(nextState, replace, callback))}
    />
    <Route path="tournament/update/:tournamentId"
      component={SetupUpdateGeneralContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupUpdateRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/communication"
      component={CommunicationFormContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleUpdateCommunicationRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/permissions"
      component={PermissionsFormContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupPermissionsRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/events"
      component={EventsContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupEventsRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/squads"
      component={SquadsContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupSquadsRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/divisions"
      component={DivisionsContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupDivisionsRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/capacity"
      component={CapacityContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupCapacityRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/fees"
      component={FeesContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupFeesRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
    <Route path="tournament/update/:tournamentId/restrictions"
        component={RestrictionsTabContainer}
        role={managerRole}
        onEnter={(nextState, replace, callback) =>
          store.dispatch(handleSetupRestrictionsRouteEnter(nextState, replace, callback))}
        onLeave={() => store.dispatch(handleRouteLeave())}
      />
    <Route path="tournament/update/:tournamentId/status"
      component={StatusContainer}
      role={managerRole}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleSetupStatusRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(handleRouteLeave())}
    />
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/features/tournament/routes.js